import React from 'react';
import { useNavigate } from 'react-router-dom';
import { VenereBox, VenereButton, VenereIconBox } from "../../shared/ui";
import { getQuickActionConfig } from "../config/quickActionConfig";
import { QuickAction } from "../types/QuickAction";

interface VenereQuickActionsProps {
}

const VenereQuickActions: React.FC<VenereQuickActionsProps> = () => {
    return (
        <VenereBox variant="seasalt">
            <div className="h-full w-full flex flex-col gap-4 items-start md:items-center">
                <div className="venere-text-primary">
                    Cosa puoi fare?
                </div>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-4xl">
                    <QuickActionBox action={QuickAction.AddMeal} />
                    <QuickActionBox action={QuickAction.SaveWeight} />
                    <QuickActionBox action={QuickAction.NextInjection} />
                    <QuickActionBox action={QuickAction.BookConsult} />
                </div>
            </div>
        </VenereBox>
    )
}

export default VenereQuickActions

const QuickActionBox: React.FC<{ action: QuickAction }> = ({ action }) => {
    const config = getQuickActionConfig(action);
    const navigate = useNavigate();

    return (
        <VenereBox variant="skin">
            <div className=" flex flex-col gap-3 h-full lg:gap-0 lg:justify-between">
                <div className="flex items-start justify-between lg:text-left gap-2">
                    <VenereIconBox 
                        icon={config.icon}
                        size={35}
                        color="var(--venere-skin)"
                        backgroundColor="var(--venere-navy)"
                    />
                    <div className="flex-1 min-w-0 space-y-2 venere-text-secondary break-words leading-[15px]">
                        <div className="font-bold">
                            {config.title}
                        </div>
                        <div>
                            {config.comment}
                        </div>
                    </div>
                </div>

                <VenereButton className="mt-auto lg:mt-4" onClick={() => navigate(config.redirect)}>
                    {config.buttonText}
                </VenereButton>
            </div>
        </VenereBox>
    )
}
